import { appConfig } from "@common-config/app.config";

/**
 * Shared navigation utility for opening app pages in new tabs
 * Uses window.open instead of React Router to work across different contexts
 * (extension, website, etc.)
 */
export const navigateToEngines = () => {
  const engineURL = `${appConfig.APP_ENDPOINT}/connections`;
  window.open(engineURL, "_blank");
};

/**
 * Navigate to any app page using the app endpoint
 * @param path - The path to navigate to (e.g., '/connections', '/calendar')
 */
export const navigateToAppPage = (path: string) => {
  const url = `${appConfig.APP_ENDPOINT}${path.startsWith('/') ? path : `/${path}`}`;
  window.open(url, "_blank");
};
